/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Fx_RatesInputs */

const en_setup_fx_rates = /** @type {(inputs: Setup_Fx_RatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exchange rates`)
};

/**
* | output |
* | --- |
* | "Exchange rates" |
*
* @param {Setup_Fx_RatesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const setup_fx_rates = /** @type {((inputs?: Setup_Fx_RatesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Fx_RatesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_setup_fx_rates(inputs)
});